import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { fetchAuthSession } from 'aws-amplify/auth';
import { from, Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { APP_CONFIG, AppConfig } from '../../../../app.config';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {

  constructor(@Inject(APP_CONFIG) private readonly config: AppConfig) { }

   intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.isRogon(request)) {
      return next.handle(request);
    }

    return from(this.getAccessToken()).pipe(
      mergeMap((token: string) => {
        if (!token) return next.handle(request);
        return next.handle(this.getAuthorizedRequest(request, token));
      }),
    );
  }

  async getAccessToken(): Promise<string>  {
    try {
      const session = await fetchAuthSession();
      return session.tokens!.accessToken!.toString();
    } catch (err) {
      console.error('Interceptor: Could not fetch auth session', err);
      return '';
    }
  }

  private getAuthorizedRequest(request: HttpRequest<unknown>, token: string): HttpRequest<unknown> {
    return request.clone({ 
      setHeaders: { Authorization: `Bearer ${token}` }
    });
  }

  private isRogon(request: HttpRequest<unknown>): boolean {
    if (!request.url) return false;

    return (
      request.url.includes(this.config.profileUrl) ||
        request.url.includes(this.config.competitionUrl)
    );
  }
}
